import styled from 'styled-components';

export const WrapperStyled = styled.div`
    height: 100vh;
    width: 100%;
    z-index: 999;
    background-color: white;
    position: absolute;
`;